<template>
  <v-main>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-stepper v-model="e1" class="stepper_bourse" v-show="autorise">
      <v-row>
        <v-col cols="6" style="align-self: center">
          <v-img
            src="@/assets/FIRSILOGO.png"
            contain
            max-height="25"
            max-width="150"
            class="d-flex justify-start"
          ></v-img>
        </v-col>
        <v-col cols="6" class="d-flex justify-end">
          <v-btn-toggle class="ml-auto">
            <v-btn @click="ChangerLangue('fr')">
              <v-img
                src="@/assets/france-flag-icon.svg"
                contain
                max-height="25"
              >
              </v-img>
            </v-btn>
            <v-btn @click="ChangerLangue('en')">
              <v-img
                src="@/assets/english-flag-icon.svg"
                contain
                max-height="25"
              ></v-img>
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <template v-for="(header, index) in $storeUm6p.Label.StepperHeaders">
            <v-stepper-step
            style="cursor:pointer;"
            color="secondary"
            :key="'stepper' + index"
            :complete="e1 > index + 1"
            :step="index + 1"
            v-on:click="suivant(index+1)"
            >
              {{ header }}
            </v-stepper-step>
            <v-divider :key="'divider' + index" />
          </template>
        </v-col>
        <v-col class="content-stepper" cols="9">
          <v-row class="v-stepper-content" id="stepper-content">
            <v-col cols="12">
              <v-stepper-items>
                <v-stepper-content step="1" class="scrollable">
                    <h2>Formulaire de candidature bourse FIRSI</h2>
                    <v-spacer></v-spacer>
                    <v-divider></v-divider>
                    <small>
                      Conformément à la loi 09-08, vous disposez d’un droit
                      d’accès, de rectification et d’opposition au traitement
                      de vos données personnelles. Ce traitement a été
                      autorisé par la CNDP sous le numéro A-PO-1511/2024.
                    </small>
                    <v-checkbox
                      :rules="$storeReglesBourse.obligatoire"
                      v-model="
                        $storeUm6p.Formulaire.ConditionsGenerales
                      "
                      @change="ConditionsGeneralesChange()"
                      input-value="true"
                      :readonly="$storeUm6p.Formulaire.ReadOnly"
                    >
                      <template v-slot:label>
                        <span>
                          Cochez ici pour accepter les
                          <a target="_blank" :href="LienRgpd" @click.stop>
                            conditions générales d'utilisation des données
                            personnelles</a
                          ></span
                        >
                      </template>
                    </v-checkbox>
                  </v-stepper-content>
                <v-stepper-content step="2" class="scrollable">
                  <Candidat ref="refCandidat" />
                </v-stepper-content>
                <v-stepper-content step="3" class="scrollable">
                  <Fratrie ref="refFratrie" />
                </v-stepper-content>
                <v-stepper-content step="4" class="scrollable">
                  <v-dialog v-model="dialog.tuteur.model" width="500">
                    <v-card class="text-center">
                      <v-card-title class="justify-center">
                        <h3>{{ $storeUm6p.Label.Informations }}</h3>
                      </v-card-title>
                      <v-card-text>
                        <h5>
                          {{ dialog.tuteur.texte }}
                        </h5>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          text
                          @click="dialog.tuteur.model = false"
                        >
                          {{ $storeUm6p.Label.Fermer }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <Parents ref="refParents" />
                </v-stepper-content>
                <v-stepper-content step="5" class="scrollable">
                  <v-dialog v-model="dialog.informations.model" width="500">
                    <v-card class="text-center">
                      <v-card-title class="justify-center">
                        <h3>{{ $storeUm6p.Label.Informations }}</h3>
                      </v-card-title>
                      <v-card-text>
                        <p v-html="dialog.informations.texte"></p>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          text
                          @click="dialog.informations.model = false"
                        >
                          {{ $storeUm6p.Label.Fermer }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <Revenus ref="refRevenus" />
                </v-stepper-content>
                <v-stepper-content step="6" class="scrollable">
                  <v-dialog v-model="dialog.publipostage.model" width="500">
                    <v-card>
                      <v-card-title class="text-h5 grey lighten-2">
                        {{ $storeUm6p.Label.Resume }}
                      </v-card-title>
                      <v-card-text>
                        <Publipostage />
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          :loading="btn_loading"
                          text
                          @click="dialog.publipostage.model = false"
                        >
                          {{ $storeUm6p.Label.Annuler }}
                        </v-btn>
                        <v-btn
                          color="primary"
                          :loading="btn_loading"
                          text
                          @click="SignerClick"
                        >
                          {{ $storeUm6p.Label.Enregistrer }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-stepper-content>
              </v-stepper-items>
              <v-row>
                <v-col cols="6">
                  <v-btn
                    large
                    dark
                    color="secondary"
                    v-if="e1 > 1"
                    @click.native="precedent()"
                  >
                    {{ $storeUm6p.Label.Precedent }}
                  </v-btn>
                </v-col>
                <v-col cols="6" class="text-right">
                  <v-btn
                    v-if="e1 < 6"
                    large
                    dark
                    color="secondary"
                    @click.native="suivant(e1+1)"
                    :disabled="!ShowSuivant && e1==1"
                  >
                    {{ $storeUm6p.Label.Suivant }}
                  </v-btn>
                  <v-row v-else>
                    <v-col cols="6">
                      <v-btn
                        large
                        dark
                        color="secondary"
                        v-show="!$storeUm6p.Formulaire.ReadOnly"
                        @click.native="Soumettre()"
                      >
                        {{ $storeUm6p.Label.Soumettre }}
                      </v-btn>
                    </v-col>
                    <v-col cols="6">
                      <v-btn
                        large
                        dark
                        color="secondary"
                        v-show="!$storeUm6p.Formulaire.ReadOnly"
                        @click.native="suivant(6)"
                      >
                        {{ $storeUm6p.Label.Enregistrer }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-stepper>
  </v-main>
</template>
<script>
import Candidat from "@/components/CandidatureBourseFirsi/Candidat";
import Publipostage from "@/components/CandidatureBourseFirsi/Publipostage";
import Fratrie from "@/components/Commun/Fratrie";
import Parents from "@/components/Commun/ParentsTuteurs";
import Revenus from "@/components/Commun/Revenus";

export default {
  name: "candidatureboursefirsi",
  components: {
    Candidat,
    Fratrie,
    Parents,
    Revenus,
    Publipostage,
  },
  data() {
    return {
      autorise: false,
      loader: false,
      // Stepper
      e1: 1,
      // Store
      $storeUm6p: this.$storeUm6p,
      storeCommun: this.$storeCommun,

      // dialog
      dialog: {
        tuteur: {
          model: false,
          texte: "",
        },
        informations: {
          model: false,
          texte: "",
        },
        publipostage: {
          model: false,
        },
      },
      ListeErreurs: [],
      btn_loading: false,
      LienRgpd: null,
      ShowSuivant: false,
    };
  },
  methods: {
    ConditionsGeneralesChange() {
      if (this.$storeUm6p.Formulaire.ConditionsGenerales) {
        this.ShowSuivant = true;
      } else {
        this.ShowSuivant = false;
      }
    },
    async Soumettre() {
      this.$storeUm6p.AffecterStoreCommun(this.$storeCommun);
      if (this.token) {
        this.loader = true;
        const reponse = await this.$storeUm6p.SaveEtape(this.token, this.e1);
        if(reponse != "error"){
          this.$storeUm6p.ParseToFormulaire(
            reponse.formulaire,
            this.$storeCommun
          );

          this.ChampsObligatoiresSoumission();

          if (this.ListeErreurs.length > 0) {
            this.AfficherListeErreurs(this.ListeErreurs);
            this.loader = false;
            return;
          } else {
            this.Publipostage();
          }
        }
        else{
          this.dialog.informations.texte = "Une erreur est survenue";
          this.dialog.informations.model = true;
          this.loader = false;
        }
      }
    },
    async Publipostage() {
      const reponse = await this.$storeUm6p.Publiposter(this.token);
      if(reponse != "error"){
        this.$storeUm6p.Formulaire.LienDocument = reponse.data;
        this.dialog.publipostage.model = true;
        this.loader = false;
      }
      else{
        this.dialog.informations.texte = "Une erreur est survenue";
        this.dialog.informations.model = true;
        this.loader = false;
      }
    },
    SignerClick() {
      if (!this.$storeUm6p.Formulaire.PublipostageSigne.DonneePieceJointe) {
        var erreur = ["Veuillez ajouter le résumé signé"];
        this.AfficherListeErreurs(erreur);
        return;
      }

      this.loader = true;
      this.btn_loading = true;
      let self = this;
      Promise.all([
        this.$storeUm6p.Signer(this.token).then((reponse) => {
          if (reponse && reponse.data) {
            if (
              reponse.data.etatDuDossier.id ==
              this.$storeCatalogue.DataId.CandidatureBourseFirsiSoumis
            ) {
              this.dialog.informations.texte =
                "Votre demande a bien été enregistrée";
              this.dialog.informations.model = true;
              this.$storeUm6p.ParseToFormulaire(
                reponse.data,
                this.$storeCommun
              );
            }
          }
        }),
      ])
        .then(function () {
          self.loader = false;
          self.btn_loading = false;
          self.dialog.publipostage.model = false;
        })
        .catch((error) => {
          console.log(error);
          self.loader = false;
          self.btn_loading = false;
          self.dialog.publipostage.model = false;
        });
    },
    ChampsObligatoiresSoumission() {
      this.ListeErreurs = [];
      this.PushListeErreur(
        this.$storeUm6p.Label.Title.Candidat + " : ",
        this.$refs.refCandidat.ValiderForm()
      );
      this.PushListeErreur(
        this.$storeUm6p.Label.Title.Revenus + " : ",
        this.$refs.refRevenus.ValiderForm()
      );

      // Annexes
      if (
        this.$storeUm6p.Formulaire.ListeAnnexesFirsi.filter((item) => {
          return item.ObligatoireSoumettre == true && !item.NomFichier;
        }).length > 0
      ) {
        this.ListeErreurs.push(
          this.$storeUm6p.Label.Annexes.AnnexesObligatoires
        );
      }

      return this.ListeErreurs;
    },
    AfficherListeErreurs(listeErreurs) {
      if (listeErreurs && listeErreurs.length > 0) {
        this.dialog.informations.texte =
          "Veuillez renseigner les informations suivantes : <br>";
        listeErreurs.forEach((item) => {
          this.dialog.informations.texte += item + "<br>";
        });
        this.dialog.informations.model = true;
        return;
      }
    },
    PushListeErreur(nomEtape, liste) {
      if (liste != undefined && liste.length > 0) {
        this.ListeErreurs.push(nomEtape);
        liste.forEach((e) => {
          this.ListeErreurs.push("- " + e);
        });
      }
    },
    ChangerLangue(langue) {
      // Mettre à jour la langue des rules
      this.$rules.lang = langue;
      if (langue === "en") {
        this.$storeUm6p.Label = this.$storeUm6p.LabelEN;
        this.$storeCommun.ItemLang = "lang01";
      } else {
        this.$storeUm6p.Label = this.$storeUm6p.LabelFR;
        this.$storeCommun.ItemLang = "lang00";
      }
    },
    precedent() {
      if (!this.$storeUm6p.Formulaire.ReadOnly) {
        // Vérifier la présence de tuteur
        if (this.token) {
          this.$storeUm6p.AffecterStoreCommun(this.$storeCommun);
          var self = this;
          this.loader = true;
          Promise.all([
            this.$storeUm6p
              .SaveEtape(this.token, this.e1)
              .then((reponse) => {
                if (reponse && reponse.data) {
                  this.$storeUm6p.ParseToFormulaire(
                    reponse.data.formulaire,
                    this.$storeCommun
                  );
                }
              })
              .catch(function (error) {
                if (error) {
                  console.log(error);
                }
              }),
          ]).then(function () {
            self.loader = false;
            self.e1--;
          });
        } else {
          this.e1--;
        }
      } else {
        this.e1--;
      }
      window.scrollTo(0, 0);
    },
    async suivant(etapeCible) {
      if (!this.$storeUm6p.Formulaire.ReadOnly) {
        // Vérifier la présence de tuteur
        if (this.e1 == 4 && Number(this.e1) < Number(etapeCible)) {
          let test = this.VerifierTuteurs(true);
          if (!test) {
            return;
          }
        }

        if (this.token) {
          this.$storeUm6p.AffecterStoreCommun(this.$storeCommun);
          this.loader = true;
          // Enregistrer la candidature.
          const reponse = await this.$storeUm6p.SaveEtape(this.token, this.e1);
          if(reponse != "error"){
              this.$storeUm6p.ParseToFormulaire(reponse.formulaire,this.$storeCommun);
              this.loader = false;
              // Verifier étape.
              let etapeFinale = etapeCible;
              let listeErreurs = [];
              if(Number(this.e1) < Number(etapeCible)){
                // Vérifier les champs obligatoires pour chaque étapes entre l'étape actuelle et l'étape demandée.
                for(let i = this.e1; i < etapeFinale; i++){
                  if(i === 2){
                    listeErreurs = this.$refs.refCandidat.ValiderForm();
                  }

                  if (i == 4) {
                    let test = this.VerifierTuteurs(true);
                    if (!test) {
                      this.e1 = i;
                      return;
                    }
                  }
                  else if(i === 5){
                    listeErreurs = this.$refs.refRevenus.ValiderForm();
                  }

                  if(listeErreurs.length > 0){
                    etapeFinale = i;
                  }
                }
              }

              this.e1 = etapeFinale;
          }
        } 
      } 
      else{
        this.e1 = etapeCible;
      }

      window.scrollTo(0, 0);
    },
    VerifierTuteurs(show) {
      this.$storeCommun.CountNombreTuteurs(this.$storeCommun.ListeSituationsFamiliale);

      // Vérifier si au moins un tuteur est présent.
      if (
        this.$storeCommun.InfosCandidature.EtesVous !=
          this.$storeCatalogue.DataId.ChargeSansTuteur &&
        this.$storeCommun.NombreTuteurs < 1
      ) {
        if (show) {
          this.dialog.tuteur.model = true;
          this.dialog.tuteur.texte = this.$storeUm6p.Label.Parents.MsgTuteur;
        }
        return false;
      }

      // Si à la charge de 2 parents mariés, vérifier qu'on a bien au moins 2 parents tuteurs.
      if (
        this.$storeCommun.InfosCandidature.EtesVous &&
        this.$storeCommun.InfosCandidature.EtesVous ==
          this.$storeCatalogue.DataId.ChargeDeuxParentsMaries 
      ) {
        if (this.$storeCommun.NombreTuteurs < 2) {
          if (show) {
            this.dialog.tuteur.model = true;
            this.dialog.tuteur.texte =
              this.$storeUm6p.Label.Parents.MsgParentsMaries;
          }
          return false;
        }

        // Vérifier si on a bien 2 parents tuteur au statut mariés.
        let parentsMaries = this.$storeCommun.NombreParentParStatutParentTuteur(this.$storeCatalogue.SituationFamMarie, this.$storeCatalogue.DataId.Oui);
        if (parentsMaries < 2) {
          if (show) {
            this.dialog.tuteur.model = true;
            this.dialog.tuteur.texte =
              this.$storeUm6p.Label.Parents.MsgSituationParents;
          }
          return false;
        }
      }

      // Si le candidat est à la charge d'un parent veuf.
      if (
        this.$storeCommun.InfosCandidature.EtesVous &&
        this.$storeCommun.InfosCandidature.EtesVous ==
          this.$storeCatalogue.DataId.ChargeUnParentVeuf
      ){
        // Vérifier que le candidat a bien ajouté les informations de son parent décédé
        let parentDecede = this.$storeCommun.ListeSituationsFamiliale.filter(
          (item) => {
            return (
              item.Supprimer == false &&
              item.StatutParentTuteur == this.$storeCatalogue.SituationFamDecede
            );
          }
        )[0];

        if (
          !parentDecede ||
          !parentDecede.Nom ||
          !parentDecede.Prenom ||
          !parentDecede.Civilite ||
          !parentDecede.Nationalite
        ) {
          if (show) {
            this.dialog.tuteur.model = true;
            this.dialog.tuteur.texte =
              this.$storeUm6p.Label.Parents.MsgSituationParentVeuf;
          }
          return false;
        }
      }

      let nbTuteurPere = this.$storeCommun.NombreTuteurParente(this.$storeCatalogue.DataId.ParentePere, this.$storeCatalogue.DataId.Oui);
      let nbTuteurMere = this.$storeCommun.NombreTuteurParente(this.$storeCatalogue.DataId.ParenteMere, this.$storeCatalogue.DataId.Oui);

      // Si le candidat est à la charge d'un de ses 2 parents veuf ou divorcé.
      if((this.$storeCommun.InfosCandidature.EtesVous ===
          this.$storeCatalogue.DataId.ChargeUnParentVeuf
        || this.$storeCommun.InfosCandidature.EtesVous ===
          this.$storeCatalogue.DataId.ChargeUnParentDivorce)
      && this.$storeCommun.InfosCandidature.ChargeUnParent)
      {
        // Vérifier que le parent nommé comme tuteur est bien présent :
        // Dans le cas où il a indiqué être à la charge de sa mère.
        if((this.$storeCommun.InfosCandidature.ChargeUnParent === this.$storeCatalogue.DataId.GardeMere
          || this.$storeCommun.InfosCandidature.ChargeUnParent === this.$storeCatalogue.DataId.TutelleMere)
          && (nbTuteurMere < 1 || nbTuteurPere > 0)
        )
        {
          if (show) {
            this.dialog.tuteur.model = true;
            this.dialog.tuteur.texte =
            this.$storeUm6p.Label.Parents.MsgTuteurMere;
          }
          return false;
        }
        // Dans le cas où il a indiqué être à la charge de son père.
        if((this.$storeCommun.InfosCandidature.ChargeUnParent === this.$storeCatalogue.DataId.GardePere
          || this.$storeCommun.InfosCandidature.ChargeUnParent === this.$storeCatalogue.DataId.TutellePere)
          && (nbTuteurPere < 1 || nbTuteurMere > 0)
        )
        {
          if (show) {
            this.dialog.tuteur.model = true;
            this.dialog.tuteur.texte =
            this.$storeUm6p.Label.Parents.MsgTuteurPere;
          }
          return false;
        }
      }

      return true;
    },
  },
  created() {
    document.title = "BOURSE UM6P";
  },
  mounted() {
    let token = this.$route.query.t;
    if (token) {
      this.token = token.replace(/\s/g, "+");
    }
    this.LienRgpd = process.env.VUE_APP_URL_CNDP;

    this.loader = true;
    const self = this;
    Promise.all([
      this.$storeCatalogue.ChargerCatalogueCandidatureBourseFirsi(),
      this.$storeUm6p
        .ChargerFormulaire(token)
        .then((reponse) => {
          if (reponse && reponse.data && reponse.status == 200) {
            this.autorise = reponse.data.autorise;
            if (this.autorise === true) {
              this.$storeUm6p.ParseToFormulaire(
                reponse.data,
                this.$storeCommun
              );
              // Initialisation de ShowSuivant après le chargement
              this.ConditionsGeneralesChange();
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
        }),
    ])
      .then(function () {
        self.loader = false;
        if (self.autorise === false) {
          self.$router.push("/NonConnecte");
        }
      })
      .catch((error) => {
        self.loader = false;
        console.log(error);
      });
  },
};
</script>
<style scoped src="@/assets/css/DemandeBourse.css"></style>
<style scoped src="@/assets/css/Um6pAutresRevenus.css"></style>
